import * as React from "react";
const SvgSubmitArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 10, viewBox: "0 0 11 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 5H9M5 9L9 5L5 1", strokeWidth: 2, strokeLinecap: "round", stroke: "white" }));
export default SvgSubmitArrow;
